export default function formTracking() {
	const forms = document.querySelectorAll('.fui-form');
	if (forms && typeof dataLayer !== 'undefined') {
		forms.forEach(form => {
			form.addEventListener('onFormieValidate', function (e) {
				// console.log('onFormieValidate');
				dataLayer.push({
					'event': 'form-submission',
					'engagement_type': 'submit attempt'
				});
			})
			form.addEventListener('onAfterFormieSubmit', function (e) {
				// console.log('onAfterFormieSubmit');
				dataLayer.push({
					'event': 'form-submission',
					'engagement_type': 'submit'
				});
			});
			form.addEventListener('onFormieSubmitError', function (e) {
				// console.log('onFormieSubmitError');
				dataLayer.push({
					'event': 'form-submission',
					'engagement_type': 'submit error'
				});
			});
		})
	}
}